// Recommended external partners shown on the "We Love" page + Home strip.
// To add a partner: append an entry. `slug` is used for reciprocal ?from= welcome.
export const PARTNERS = [
  {
    slug: "makeupbrushbasics",
    name: "Makeup Brush Basics",
    url: "https://www.makeupbrushbasics.com",
    logo: "/partners/makeupbrushbasics-v3.png",
    tagline: "Your brush guide to flawless beauty",
    blurb: "Pro tips, guides and everything you need to know about makeup brushes.",
  },
];

// Attribution code appended to every outbound partner link so partners can see
// the traffic Beauty Trade Club sends them.
export const OUTBOUND_REF = "beautytradeclub";

export function partnerOutUrl(partner) {
  try {
    const u = new URL(partner.url);
    u.searchParams.set("ref", OUTBOUND_REF);
    u.searchParams.set("utm_source", "beautytradeclub");
    u.searchParams.set("utm_medium", "we-love");
    return u.toString();
  } catch {
    return partner.url;
  }
}

export function findPartnerBySlug(slug) {
  if (!slug) return null;
  return PARTNERS.find((p) => p.slug === slug.toLowerCase()) || null;
}
